import React, { FC } from 'react';
import { AddEntityWatcherButton } from '../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';

type Props = {
  enterpriseId: string;
  raisonSociale: string;
};

export const EntepriseFollowButton: FC<Props> = ({
  raisonSociale,
  enterpriseId,
}) => {
  const source = 'enterprise_snippet';
  const { openRestrictedModal } = useRestrictedModal();
  const showRestrictedModal = () => {
    openRestrictedModal({ source: 'want_to_follow_enterprise' });
  };
  return (
    <AddEntityWatcherButton
      query={raisonSociale}
      entityIdParams={{ eid: enterpriseId }}
      uniqueId={enterpriseId}
      restrict={showRestrictedModal}
      source={source}
      secondary
    />
  );
};
